import { BaseProxy } from "@/proxies/BaseProxy";

export class UsersProxy extends BaseProxy {
  constructor({ parameters = {} } = {}) {
    super({
      endpoint: `users`,
      parameters,
    });
  }
}
